/*!
 * froala_editor v4.1.2 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2023 Froala Labs
 */

!(function (t, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? e(require('froala-editor'))
    : 'function' == typeof define && define.amd
    ? define(['froala-editor'], e)
    : e(t.FroalaEditor);
})(this, function (t) {
  'use strict';
  (t =
    t && t.hasOwnProperty('default')
      ? t['default']
      : t).PLUGINS.codeBeautifier = function () {
    var t,
      e,
      n,
      i,
      Q = {};
    function y(i, t) {
      var e = {
          '@page': !0,
          '@font-face': !0,
          '@keyframes': !0,
          '@media': !0,
          '@supports': !0,
          '@document': !0
        },
        n = { '@media': !0, '@supports': !0, '@document': !0 };
      (t = t || {}),
        (i = (i = i || '').replace(/\r\n|[\r\u2028\u2029]/g, '\n'));
      var r = t.indent_size || 4,
        s = t.indent_char || ' ',
        a =
          t.selector_separator_newline === undefined ||
          t.selector_separator_newline,
        _ = t.end_with_newline !== undefined && t.end_with_newline,
        o = t.newline_between_rules === undefined || t.newline_between_rules,
        c = t.eol ? t.eol : '\n';
      'string' == typeof r && (r = parseInt(r, 10)),
        t.indent_with_tabs && ((s = '\t'), (r = 1)),
        (c = c.replace(/\\r/, '\r').replace(/\\n/, '\n'));
      var l,
        h = /^\s+$/,
        u = -1,
        p = 0;
      function d() {
        return (l = i.charAt(++u)) || '';
      }
      function f(t) {
        var e,
          n = u;
        return t && E(), (e = i.charAt(u + 1) || ''), (u = n - 1), d(), e;
      }
      function T(t) {
        for (var e = u; d(); )
          if ('\\' === l) d();
          else {
            if (-1 !== t.indexOf(l)) break;
            if ('\n' === l) break;
          }
        return i.substring(e, u + 1);
      }
      function E() {
        for (var t = ''; h.test(f()); ) d(), (t += l);
        return t;
      }
      function g() {
        var t = '';
        for (l && h.test(l) && (t = l); h.test(d()); ) t += l;
        return t;
      }
      function x(t) {
        var e = u;
        for (t = '/' === f(), d(); d(); ) {
          if (!t && '*' === l && '/' === f()) {
            d();
            break;
          }
          if (t && '\n' === l) return i.substring(e, u);
        }
        return i.substring(e, u) + l;
      }
      function w(t) {
        return i.substring(u - t.length, u).toLowerCase() === t;
      }
      function K() {
        for (var t = 0, e = u + 1; e < i.length; e++) {
          var n = i.charAt(e);
          if ('{' === n) return !0;
          if ('(' === n) t += 1;
          else if (')' === n) {
            if (0 === t) return !1;
            t -= 1;
          } else if (' ' === n || '}' === n) return !1;
        }
        return !1;
      }
      var R = i.match(/^[\t ]*/)[0],
        m = new Array(r + 1).join(s),
        b = 0,
        v = 0;
      for (
        var S,
          A,
          k,
          y = {
            '{': function (t) {
              y.singleSpace(), O.push(t), y.newLine();
            },
            '}': function (t) {
              y.newLine(), O.push(t), y.newLine();
            },
            _lastCharWhitespace: function () {
              return h.test(O[O.length - 1]);
            },
            newLine: function (t) {
              O.length &&
                (t || '\n' === O[O.length - 1] || y.trim(),
                O.push('\n'),
                R && O.push(R));
            },
            singleSpace: function () {
              O.length && !y._lastCharWhitespace() && O.push(' ');
            },
            preserveSingleSpace: function () {
              S && y.singleSpace();
            },
            trim: function () {
              for (; y._lastCharWhitespace(); ) O.pop();
            }
          },
          O = [],
          N = !1,
          D = !1,
          C = !1,
          L = '',
          I = '';
        ;

      ) {
        var V = g();
        S = '' !== V;
        var P = -1 !== V.indexOf('\n');
        if (((I = L), !(L = l))) break;
        if ('/' === l && '*' === f()) {
          var B = 0 === b;
          (P || B) && y.newLine(), O.push(x()), y.newLine(), B && y.newLine(!0);
        } else if ('/' === l && '/' === f())
          P || '{' === I || y.trim(), y.singleSpace(), O.push(x()), y.newLine();
        else if ('@' === l) {
          y.preserveSingleSpace(), O.push(l);
          var j =
            (void 0, (A = u), (k = T(': , {}()[]/=\'"')), (u = A - 1), d(), k);
          j.match(/[ :]$/) &&
            (d(), (j = T(': ').replace(/\s$/, '')), O.push(j), y.singleSpace()),
            (j = j.replace(/\s$/, '')) in e && ((v += 1), j in n && (C = !0));
        } else
          '#' === l && '{' === f()
            ? (y.preserveSingleSpace(), O.push(T('}')))
            : '{' === l
            ? '}' === f(!0)
              ? (E(),
                d(),
                y.singleSpace(),
                O.push('{}'),
                y.newLine(),
                o && 0 === b && y.newLine(!0))
              : (b++, (R += m), y['{'](l), (N = C ? ((C = !1), v < b) : v <= b))
            : '}' === l
            ? (b--,
              (R = R.slice(0, -r)),
              y['}'](l),
              (D = N = !1),
              v && v--,
              o && 0 === b && y.newLine(!0))
            : ':' === l
            ? (E(),
              (!N && !C) || w('&') || K()
                ? ':' === f()
                  ? (d(), O.push('::'))
                  : O.push(':')
                : ((D = !0), O.push(':'), y.singleSpace()))
            : '"' === l || "'" === l
            ? (y.preserveSingleSpace(), O.push(T(l)))
            : ' ' === l
            ? ((D = !1), O.push(l), y.newLine())
            : '(' === l
            ? w('url')
              ? (O.push(l),
                E(),
                d() &&
                  (')' !== l && '"' !== l && "'" !== l ? O.push(T(')')) : u--))
              : (p++, y.preserveSingleSpace(), O.push(l), E())
            : ')' === l
            ? (O.push(l), p--)
            : ',' === l
            ? (O.push(l), E(), a && !D && p < 1 ? y.newLine() : y.singleSpace())
            : (']' === l ||
                ('[' === l
                  ? y.preserveSingleSpace()
                  : '=' === l
                  ? (E(), (l = '='))
                  : y.preserveSingleSpace()),
              O.push(l));
      }
      var M = '';
      return (
        R && (M += R),
        (M += O.join('').replace(/[\r\n\t ]+$/, '')),
        _ && (M += '\n'),
        '\n' != c && (M = M.replace(/[\n]/g, c)),
        M
      );
    }
    function Y(t, e) {
      for (var n = 0; n < e.length; n += 1) if (e[n] === t) return !0;
      return !1;
    }
    function H(t) {
      return t.replace(/^\s+|\s+$/g, '');
    }
    function O(t, e) {
      return new r(t, e).beautify();
    }
    (t = Q),
      (e =
        '\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc'),
      (n = new RegExp('['.concat(e, ']'))),
      (i = new RegExp(
        '['
          .concat(e, ' ')
          .concat(
            '\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f',
            ']'
          )
      )),
      (t.newline = /[\n\r\u2028\u2029]/),
      (t.lineBreak = new RegExp('\r\n|'.concat(t.newline.source))),
      (t.allLineBreaks = new RegExp(t.lineBreak.source, 'g')),
      (t.isIdentifierStart = function (t) {
        return t < 65
          ? 36 === t || 64 === t
          : t < 91 ||
              (t < 97
                ? 95 === t
                : t < 123 || (170 <= t && n.test(String.fromCharCode(t))));
      }),
      (t.isIdentifierChar = function (t) {
        return t < 48
          ? 36 === t
          : t < 58 ||
              (!(t < 65) &&
                (t < 91 ||
                  (t < 97
                    ? 95 === t
                    : t < 123 ||
                      (170 <= t && i.test(String.fromCharCode(t))))));
      });
    var Z = {
      BlockStatement: 'BlockStatement',
      Statement: 'Statement',
      ObjectLiteral: 'ObjectLiteral',
      ArrayLiteral: 'ArrayLiteral',
      ForInitializer: 'ForInitializer',
      Conditional: 'Conditional',
      Expression: 'Expression'
    };
    function r(i, t) {
      var c,
        r,
        s,
        l,
        a,
        _,
        o,
        h,
        u,
        e,
        n,
        p,
        d,
        f = [],
        T = '';
      function E(t, e) {
        var n = 0;
        return (
          t &&
            ((n = t.indentation_level),
            !c.just_added_newline() &&
              t.line_indent_level > n &&
              (n = t.line_indent_level)),
          {
            mode: e,
            parent: t,
            last_text: t ? t.last_text : '',
            last_word: t ? t.last_word : '',
            declaration_statement: !1,
            declaration_assignment: !1,
            multiline_frame: !1,
            if_block: !1,
            else_block: !1,
            do_block: !1,
            do_while: !1,
            in_case_statement: !1,
            in_case: !1,
            case_body: !1,
            indentation_level: n,
            line_indent_level: t ? t.line_indent_level : n,
            start_line_index: c.get_line_number(),
            ternary_depth: 0
          }
        );
      }
      for (
        p = {
          TK_START_EXPR: function L() {
            O();
            var t = Z.Expression;
            if ('[' === l.text) {
              if ('TK_WORD' === a || ')' === h.last_text)
                return (
                  'TK_RESERVED' === a &&
                    Y(h.last_text, s.line_starters) &&
                    (c.space_before_token = !0),
                  v(t),
                  m(),
                  b(),
                  void (d.space_in_paren && (c.space_before_token = !0))
                );
              (t = Z.ArrayLiteral),
                S(h.mode) &&
                  (('[' !== h.last_text &&
                    (',' !== h.last_text || (']' !== _ && '}' !== _))) ||
                    d.keep_array_indentation ||
                    K());
            } else
              'TK_RESERVED' === a && 'for' === h.last_text
                ? (t = Z.ForInitializer)
                : 'TK_RESERVED' === a &&
                  Y(h.last_text, ['if', 'while']) &&
                  (t = Z.Conditional);
            ' ' === h.last_text || 'TK_START_BLOCK' === a
              ? K()
              : 'TK_END_EXPR' === a ||
                'TK_START_EXPR' === a ||
                'TK_END_BLOCK' === a ||
                '.' === h.last_text
              ? w(l.wanted_newline)
              : ('TK_RESERVED' === a && '(' === l.text) ||
                'TK_WORD' === a ||
                'TK_OPERATOR' === a
              ? ('TK_RESERVED' === a &&
                  ('function' === h.last_word || 'typeof' === h.last_word)) ||
                ('*' === h.last_text && 'function' === _)
                ? d.space_after_anon_function && (c.space_before_token = !0)
                : 'TK_RESERVED' !== a ||
                  (!Y(h.last_text, s.line_starters) &&
                    'catch' !== h.last_text) ||
                  (d.space_before_conditional && (c.space_before_token = !0))
              : (c.space_before_token = !0);
            '(' === l.text &&
              'TK_RESERVED' === a &&
              'await' === h.last_word &&
              (c.space_before_token = !0);
            '(' === l.text &&
              (('TK_EQUALS' !== a && 'TK_OPERATOR' !== a) || y() || w());
            v(t), m(), d.space_in_paren && (c.space_before_token = !0);
            b();
          },
          TK_END_EXPR: function I() {
            for (; h.mode === Z.Statement; ) k();
            h.multiline_frame &&
              w(']' === l.text && S(h.mode) && !d.keep_array_indentation);
            d.space_in_paren &&
              ('TK_START_EXPR' !== a || d.space_in_empty_paren
                ? (c.space_before_token = !0)
                : (c.trim(), (c.space_before_token = !1)));
            ']' === l.text && d.keep_array_indentation
              ? (m(), k())
              : (k(), m());
            c.remove_redundant_indentation(u),
              h.do_while &&
                u.mode === Z.Conditional &&
                ((u.mode = Z.Expression), (h.do_block = !1), (h.do_while = !1));
          },
          TK_START_BLOCK: function V() {
            var t = D(1),
              e = D(2);
            e &&
            ((':' === e.text &&
              Y(t.type, ['TK_STRING', 'TK_WORD', 'TK_RESERVED'])) ||
              (Y(t.text, ['get', 'set']) &&
                Y(e.type, ['TK_WORD', 'TK_RESERVED'])))
              ? Y(_, ['class', 'interface'])
                ? v(Z.BlockStatement)
                : v(Z.ObjectLiteral)
              : v(Z.BlockStatement);
            var n =
              !t.comments_before.length &&
              '}' === t.text &&
              'function' === h.last_word &&
              'TK_END_EXPR' === a;
            'expand' === d.brace_style ||
            ('none' === d.brace_style && l.wanted_newline)
              ? 'TK_OPERATOR' !== a &&
                (n ||
                  'TK_EQUALS' === a ||
                  ('TK_RESERVED' === a &&
                    N(h.last_text) &&
                    'else' !== h.last_text))
                ? (c.space_before_token = !0)
                : K(!1, !0)
              : 'TK_OPERATOR' !== a && 'TK_START_EXPR' !== a
              ? 'TK_START_BLOCK' === a
                ? K()
                : (c.space_before_token = !0)
              : S(u.mode) &&
                ',' === h.last_text &&
                ('}' === _ ? (c.space_before_token = !0) : K());
            m(), b();
          },
          TK_END_BLOCK: function P() {
            for (; h.mode === Z.Statement; ) k();
            var t = 'TK_START_BLOCK' === a;
            'expand' === d.brace_style
              ? t || K()
              : t ||
                (S(h.mode) && d.keep_array_indentation
                  ? ((d.keep_array_indentation = !1),
                    K(),
                    (d.keep_array_indentation = !0))
                  : K());
            k(), m();
          },
          TK_WORD: C,
          TK_RESERVED: C,
          TK_SEMICOLON: function B() {
            O() && (c.space_before_token = !1);
            for (; h.mode === Z.Statement && !h.if_block && !h.do_block; ) k();
            m();
          },
          TK_STRING: function j() {
            O()
              ? (c.space_before_token = !0)
              : 'TK_RESERVED' === a || 'TK_WORD' === a
              ? (c.space_before_token = !0)
              : 'TK_COMMA' === a ||
                'TK_START_EXPR' === a ||
                'TK_EQUALS' === a ||
                'TK_OPERATOR' === a
              ? y() || w()
              : K();
            m();
          },
          TK_EQUALS: function M() {
            O();
            h.declaration_statement && (h.declaration_assignment = !0);
            (c.space_before_token = !0), m(), (c.space_before_token = !0);
          },
          TK_OPERATOR: function U() {
            O();
            if ('TK_RESERVED' === a && N(h.last_text))
              return (c.space_before_token = !0), void m();
            if ('*' === l.text && 'TK_DOT' === a) return void m();
            if (':' === l.text && h.in_case)
              return (h.case_body = !0), b(), m(), K(), void (h.in_case = !1);
            if ('::' === l.text) return void m();
            'TK_OPERATOR' === a && w();
            var t = !0,
              e = !0;
            Y(l.text, ['--', '++', '!', '~']) ||
            (Y(l.text, ['-', '+']) &&
              (Y(a, [
                'TK_START_BLOCK',
                'TK_START_EXPR',
                'TK_EQUALS',
                'TK_OPERATOR'
              ]) ||
                Y(h.last_text, s.line_starters) ||
                ',' === h.last_text))
              ? ((e = t = !1),
                !l.wanted_newline ||
                  ('--' !== l.text && '++' !== l.text) ||
                  K(!1, !0),
                ' ' === h.last_text && A(h.mode) && (t = !0),
                'TK_RESERVED' === a
                  ? (t = !0)
                  : 'TK_END_EXPR' === a
                  ? (t = !(
                      ']' === h.last_text &&
                      ('--' === l.text || '++' === l.text)
                    ))
                  : 'TK_OPERATOR' === a &&
                    ((t =
                      Y(l.text, ['--', '-', '++', '+']) &&
                      Y(h.last_text, ['--', '-', '++', '+'])),
                    Y(l.text, ['+', '-']) &&
                      Y(h.last_text, ['--', '++']) &&
                      (e = !0)),
                (h.mode !== Z.BlockStatement && h.mode !== Z.Statement) ||
                  ('{' !== h.last_text && ' ' !== h.last_text) ||
                  K())
              : ':' === l.text
              ? 0 === h.ternary_depth
                ? (t = !1)
                : (h.ternary_depth -= 1)
              : '?' === l.text
              ? (h.ternary_depth += 1)
              : '*' === l.text &&
                'TK_RESERVED' === a &&
                'function' === h.last_text &&
                (e = t = !1);
            (c.space_before_token = c.space_before_token || t),
              m(),
              (c.space_before_token = e);
          },
          TK_COMMA: function W() {
            if (h.declaration_statement)
              return (
                A(h.parent.mode) && (h.declaration_assignment = !1),
                m(),
                void (h.declaration_assignment
                  ? K((h.declaration_assignment = !1), !0)
                  : ((c.space_before_token = !0), d.comma_first && w()))
              );
            m(),
              h.mode === Z.ObjectLiteral ||
              (h.mode === Z.Statement && h.parent.mode === Z.ObjectLiteral)
                ? (h.mode === Z.Statement && k(), K())
                : ((c.space_before_token = !0), d.comma_first && w());
          },
          TK_BLOCK_COMMENT: function z() {
            if (c.raw)
              return (
                c.add_raw_token(l),
                void (
                  l.directives &&
                  'end' === l.directives.preserve &&
                  (d.test_output_raw || (c.raw = !1))
                )
              );
            if (l.directives)
              return (
                K(!1, !0),
                m(),
                'start' === l.directives.preserve && (c.raw = !0),
                void K(!1, !0)
              );
            if (!Q.newline.test(l.text) && !l.wanted_newline)
              return (
                (c.space_before_token = !0),
                m(),
                void (c.space_before_token = !0)
              );
            var t,
              e = (function a(t) {
                var e;
                t = t.replace(/\x0d/g, '');
                var n = [];
                e = t.indexOf('\n');
                for (; -1 !== e; )
                  n.push(t.substring(0, e)),
                    (t = t.substring(e + 1)),
                    (e = t.indexOf('\n'));
                t.length && n.push(t);
                return n;
              })(l.text),
              n = !1,
              i = !1,
              r = l.whitespace_before,
              s = r.length;
            K(!1, !0),
              1 < e.length &&
                (!(function _(t, e) {
                  for (var n = 0; n < t.length; n++) {
                    var i = H(t[n]);
                    if (i.charAt(0) !== e) return !1;
                  }
                  return !0;
                })(e.slice(1), '*')
                  ? (function o(t, e) {
                      for (var n, i = 0, r = t.length; i < r; i++)
                        if ((n = t[i]) && 0 !== n.indexOf(e)) return !1;
                      return !0;
                    })(e.slice(1), r) && (i = !0)
                  : (n = !0));
            for (m(e[0]), t = 1; t < e.length; t++)
              K(!1, !0),
                n
                  ? m(' '.concat(e[t].replace(/^\s+/g, '')))
                  : i && e[t].length > s
                  ? m(e[t].substring(s))
                  : c.add_token(e[t]);
            K(!1, !0);
          },
          TK_COMMENT: function G() {
            l.wanted_newline ? K(!1, !0) : c.trim(!0);
            (c.space_before_token = !0), m(), K(!1, !0);
          },
          TK_DOT: function X() {
            O();
            'TK_RESERVED' === a && N(h.last_text)
              ? (c.space_before_token = !0)
              : w(')' === h.last_text && d.break_chained_methods);
            m();
          },
          TK_UNKNOWN: function F() {
            m(), '\n' === l.text[l.text.length - 1] && K();
          },
          TK_EOF: function $() {
            for (; h.mode === Z.Statement; ) k();
          }
        },
          d = {},
          (t = t || {}).braces_on_own_line !== undefined &&
            (d.brace_style = t.braces_on_own_line ? 'expand' : 'collapse'),
          d.brace_style = t.brace_style
            ? t.brace_style
            : d.brace_style
            ? d.brace_style
            : 'collapse',
          'expand-strict' === d.brace_style && (d.brace_style = 'expand'),
          d.indent_size = t.indent_size ? parseInt(t.indent_size, 10) : 4,
          d.indent_char = t.indent_char ? t.indent_char : ' ',
          d.eol = t.eol ? t.eol : '\n',
          d.preserve_newlines =
            t.preserve_newlines === undefined || t.preserve_newlines,
          d.break_chained_methods =
            t.break_chained_methods !== undefined && t.break_chained_methods,
          d.max_preserve_newlines =
            t.max_preserve_newlines === undefined
              ? 0
              : parseInt(t.max_preserve_newlines, 10),
          d.space_in_paren = t.space_in_paren !== undefined && t.space_in_paren,
          d.space_in_empty_paren =
            t.space_in_empty_paren !== undefined && t.space_in_empty_paren,
          d.jslint_happy = t.jslint_happy !== undefined && t.jslint_happy,
          d.space_after_anon_function =
            t.space_after_anon_function !== undefined &&
            t.space_after_anon_function,
          d.keep_array_indentation =
            t.keep_array_indentation !== undefined && t.keep_array_indentation,
          d.space_before_conditional =
            t.space_before_conditional === undefined ||
            t.space_before_conditional,
          d.unescape_strings =
            t.unescape_strings !== undefined && t.unescape_strings,
          d.wrap_line_length =
            t.wrap_line_length === undefined
              ? 0
              : parseInt(t.wrap_line_length, 10),
          d.e4x = t.e4x !== undefined && t.e4x,
          d.end_with_newline =
            t.end_with_newline !== undefined && t.end_with_newline,
          d.comma_first = t.comma_first !== undefined && t.comma_first,
          d.test_output_raw =
            t.test_output_raw !== undefined && t.test_output_raw,
          d.jslint_happy && (d.space_after_anon_function = !0),
          t.indent_with_tabs && ((d.indent_char = '\t'), (d.indent_size = 1)),
          d.eol = d.eol.replace(/\\r/, '\r').replace(/\\n/, '\n'),
          o = '';
        0 < d.indent_size;

      )
        (o += d.indent_char), (d.indent_size -= 1);
      var g = 0;
      if (i && i.length) {
        for (; ' ' === i.charAt(g) || '\t' === i.charAt(g); )
          (T += i.charAt(g)), (g += 1);
        i = i.substring(g);
      }
      function x(t) {
        var e = t.newlines;
        if (d.keep_array_indentation && S(h.mode))
          for (var n = 0; n < e; n += 1) K(0 < n);
        else if (
          (d.max_preserve_newlines &&
            e > d.max_preserve_newlines &&
            (e = d.max_preserve_newlines),
          d.preserve_newlines && 1 < t.newlines)
        ) {
          K();
          for (var i = 1; i < e; i += 1) K(!0);
        }
        p[(l = t).type]();
      }
      function w(t) {
        if (((t = t !== undefined && t), !c.just_added_newline()))
          if ((d.preserve_newlines && l.wanted_newline) || t) K(!1, !0);
          else if (d.wrap_line_length) {
            c.current_line.get_character_count() +
              l.text.length +
              (c.space_before_token ? 1 : 0) >=
              d.wrap_line_length && K(!1, !0);
          }
      }
      function K(t, e) {
        if (
          !e &&
          ' ' !== h.last_text &&
          ',' !== h.last_text &&
          '=' !== h.last_text &&
          'TK_OPERATOR' !== a
        )
          for (; h.mode === Z.Statement && !h.if_block && !h.do_block; ) k();
        c.add_new_line(t) && (h.multiline_frame = !0);
      }
      function R() {
        c.just_added_newline() &&
          (d.keep_array_indentation && S(h.mode) && l.wanted_newline
            ? (c.current_line.push(l.whitespace_before),
              (c.space_before_token = !1))
            : c.set_indent(h.indentation_level) &&
              (h.line_indent_level = h.indentation_level));
      }
      function m(t) {
        c.raw
          ? c.add_raw_token(l)
          : (d.comma_first &&
              'TK_COMMA' === a &&
              c.just_added_newline() &&
              ',' === c.previous_line.last() &&
              (c.previous_line.pop(),
              R(),
              c.add_token(','),
              (c.space_before_token = !0)),
            (t = t || l.text),
            R(),
            c.add_token(t));
      }
      function b() {
        h.indentation_level += 1;
      }
      function v(t) {
        (u = h ? (e.push(h), h) : E(null, t)), (h = E(u, t));
      }
      function S(t) {
        return t === Z.ArrayLiteral;
      }
      function A(t) {
        return Y(t, [Z.Expression, Z.ForInitializer, Z.Conditional]);
      }
      function k() {
        0 < e.length &&
          ((u = h),
          (h = e.pop()),
          u.mode === Z.Statement && c.remove_redundant_indentation(u));
      }
      function y() {
        return (
          h.parent.mode === Z.ObjectLiteral &&
          h.mode === Z.Statement &&
          ((':' === h.last_text && 0 === h.ternary_depth) ||
            ('TK_RESERVED' === a && Y(h.last_text, ['get', 'set'])))
        );
      }
      function O() {
        return (
          !!(
            ('TK_RESERVED' === a &&
              Y(h.last_text, ['const', 'let', 'const']) &&
              'TK_WORD' === l.type) ||
            ('TK_RESERVED' === a && 'do' === h.last_text) ||
            ('TK_RESERVED' === a &&
              'return' === h.last_text &&
              !l.wanted_newline) ||
            ('TK_RESERVED' === a &&
              'else' === h.last_text &&
              ('TK_RESERVED' !== l.type || 'if' !== l.text)) ||
            ('TK_END_EXPR' === a &&
              (u.mode === Z.ForInitializer || u.mode === Z.Conditional)) ||
            ('TK_WORD' === a &&
              h.mode === Z.BlockStatement &&
              !h.in_case &&
              '--' !== l.text &&
              '++' !== l.text &&
              'function' !== _ &&
              'TK_WORD' !== l.type &&
              'TK_RESERVED' !== l.type) ||
            (h.mode === Z.ObjectLiteral &&
              ((':' === h.last_text && 0 === h.ternary_depth) ||
                ('TK_RESERVED' === a && Y(h.last_text, ['get', 'set']))))
          ) &&
          (v(Z.Statement),
          b(),
          'TK_RESERVED' === a &&
            Y(h.last_text, ['const', 'let', 'const']) &&
            'TK_WORD' === l.type &&
            (h.declaration_statement = !0),
          y() ||
            w(
              'TK_RESERVED' === l.type &&
                Y(l.text, ['do', 'for', 'if', 'while'])
            ),
          !0)
        );
      }
      function N(t) {
        return Y(t, ['case', 'return', 'do', 'if', 'throw', 'else']);
      }
      function D(t) {
        var e = r + (t || 0);
        return e < 0 || e >= f.length ? null : f[e];
      }
      function C() {
        ('TK_RESERVED' === l.type &&
          h.mode !== Z.ObjectLiteral &&
          Y(l.text, ['set', 'get']) &&
          (l.type = 'TK_WORD'),
        'TK_RESERVED' === l.type && h.mode === Z.ObjectLiteral) &&
          ':' === D(1).text &&
          (l.type = 'TK_WORD');
        if (
          (O() ||
            !l.wanted_newline ||
            A(h.mode) ||
            ('TK_OPERATOR' === a &&
              '--' !== h.last_text &&
              '++' !== h.last_text) ||
            'TK_EQUALS' === a ||
            (!d.preserve_newlines &&
              'TK_RESERVED' === a &&
              Y(h.last_text, ['const', 'let', 'const', 'set', 'get'])) ||
            K(),
          h.do_block && !h.do_while)
        ) {
          if ('TK_RESERVED' === l.type && 'while' === l.text)
            return (
              (c.space_before_token = !0),
              m(),
              (c.space_before_token = !0),
              void (h.do_while = !0)
            );
          K(), (h.do_block = !1);
        }
        if (h.if_block)
          if (h.else_block || 'TK_RESERVED' !== l.type || 'else' !== l.text) {
            for (; h.mode === Z.Statement; ) k();
            (h.if_block = !1), (h.else_block = !1);
          } else h.else_block = !0;
        if (
          'TK_RESERVED' === l.type &&
          ('case' === l.text || ('default' === l.text && h.in_case_statement))
        )
          return (
            K(),
            (h.case_body || d.jslint_happy) &&
              (!(function t() {
                0 < h.indentation_level &&
                  (!h.parent ||
                    h.indentation_level > h.parent.indentation_level) &&
                  (h.indentation_level -= 1);
              })(),
              (h.case_body = !1)),
            m(),
            (h.in_case = !0),
            void (h.in_case_statement = !0)
          );
        if (
          ('TK_RESERVED' === l.type &&
            'function' === l.text &&
            ((Y(h.last_text, ['}', ' ']) ||
              (c.just_added_newline() &&
                !Y(h.last_text, ['[', '{', ':', '=', ',']))) &&
              (c.just_added_blankline() ||
                l.comments_before.length ||
                (K(), K(!0))),
            'TK_RESERVED' === a || 'TK_WORD' === a
              ? 'TK_RESERVED' === a &&
                Y(h.last_text, [
                  'get',
                  'set',
                  'new',
                  'return',
                  'export',
                  'async'
                ])
                ? (c.space_before_token = !0)
                : 'TK_RESERVED' === a &&
                  'default' === h.last_text &&
                  'export' === _
                ? (c.space_before_token = !0)
                : K()
              : 'TK_OPERATOR' === a || '=' === h.last_text
              ? (c.space_before_token = !0)
              : (h.multiline_frame || (!A(h.mode) && !S(h.mode))) && K()),
          ('TK_COMMA' !== a &&
            'TK_START_EXPR' !== a &&
            'TK_EQUALS' !== a &&
            'TK_OPERATOR' !== a) ||
            y() ||
            w(),
          'TK_RESERVED' === l.type && Y(l.text, ['function', 'get', 'set']))
        )
          return m(), void (h.last_word = l.text);
        ((n = 'NONE'),
        'TK_END_BLOCK' === a
          ? 'TK_RESERVED' === l.type && Y(l.text, ['else', 'catch', 'finally'])
            ? 'expand' === d.brace_style ||
              'end-expand' === d.brace_style ||
              ('none' === d.brace_style && l.wanted_newline)
              ? (n = 'NEWLINE')
              : ((n = 'SPACE'), (c.space_before_token = !0))
            : (n = 'NEWLINE')
          : 'TK_SEMICOLON' === a && h.mode === Z.BlockStatement
          ? (n = 'NEWLINE')
          : 'TK_SEMICOLON' === a && A(h.mode)
          ? (n = 'SPACE')
          : 'TK_STRING' === a
          ? (n = 'NEWLINE')
          : 'TK_RESERVED' === a ||
            'TK_WORD' === a ||
            ('*' === h.last_text && 'function' === _)
          ? (n = 'SPACE')
          : 'TK_START_BLOCK' === a
          ? (n = 'NEWLINE')
          : 'TK_END_EXPR' === a &&
            ((c.space_before_token = !0), (n = 'NEWLINE')),
        'TK_RESERVED' === l.type &&
          Y(l.text, s.line_starters) &&
          ')' !== h.last_text &&
          (n =
            'else' === h.last_text || 'export' === h.last_text
              ? 'SPACE'
              : 'NEWLINE'),
        'TK_RESERVED' === l.type && Y(l.text, ['else', 'catch', 'finally']))
          ? 'TK_END_BLOCK' !== a ||
            'expand' === d.brace_style ||
            'end-expand' === d.brace_style ||
            ('none' === d.brace_style && l.wanted_newline)
            ? K()
            : (c.trim(!0),
              '}' !== c.current_line.last() && K(),
              (c.space_before_token = !0))
          : 'NEWLINE' === n
          ? 'TK_RESERVED' === a && N(h.last_text)
            ? (c.space_before_token = !0)
            : 'TK_END_EXPR' !== a
            ? ('TK_START_EXPR' === a &&
                'TK_RESERVED' === l.type &&
                Y(l.text, ['const', 'let', 'const'])) ||
              ':' === h.last_text ||
              ('TK_RESERVED' === l.type &&
              'if' === l.text &&
              'else' === h.last_text
                ? (c.space_before_token = !0)
                : K())
            : 'TK_RESERVED' === l.type &&
              Y(l.text, s.line_starters) &&
              ')' !== h.last_text &&
              K()
          : h.multiline_frame && S(h.mode) && ',' === h.last_text && '}' === _
          ? K()
          : 'SPACE' === n && (c.space_before_token = !0);
        m(),
          (h.last_word = l.text),
          'TK_RESERVED' === l.type && 'do' === l.text && (h.do_block = !0),
          'TK_RESERVED' === l.type && 'if' === l.text && (h.if_block = !0);
      }
      (a = 'TK_START_BLOCK'),
        (_ = ''),
        ((c = new q(o, T)).raw = d.test_output_raw),
        (e = []),
        v(Z.BlockStatement),
        (this.beautify = function () {
          var t, e;
          for (s = new tt(i, d, o), f = s.tokenize(), r = 0; (t = D()); ) {
            for (var n = 0; n < t.comments_before.length; n++)
              x(t.comments_before[n]);
            x(t),
              (_ = h.last_text),
              (a = t.type),
              (h.last_text = t.text),
              (r += 1);
          }
          return (
            (e = c.get_code()),
            d.end_with_newline && (e += '\n'),
            '\n' != d.eol && (e = e.replace(/[\n]/g, d.eol)),
            e
          );
        });
    }
    function s(e) {
      var n = 0,
        i = -1,
        r = [],
        s = !0;
      (this.set_indent = function (t) {
        (n = e.baseIndentLength + t * e.indent_length), (i = t);
      }),
        (this.get_character_count = function () {
          return n;
        }),
        (this.is_empty = function () {
          return s;
        }),
        (this.last = function () {
          return this._empty ? null : r[r.length - 1];
        }),
        (this.push = function (t) {
          r.push(t), (n += t.length), (s = !1);
        }),
        (this.pop = function () {
          var t = null;
          return s || ((t = r.pop()), (n -= t.length), (s = 0 === r.length)), t;
        }),
        (this.remove_indent = function () {
          0 < i && ((i -= 1), (n -= e.indent_length));
        }),
        (this.trim = function () {
          for (; ' ' === this.last(); ) r.pop(), (n -= 1);
          s = 0 === r.length;
        }),
        (this.toString = function () {
          var t = '';
          return (
            this._empty ||
              (0 <= i && (t = e.indent_cache[i]), (t += r.join(''))),
            t
          );
        });
    }
    function q(e, n) {
      (n = n || ''),
        (this.indent_cache = [n]),
        (this.baseIndentLength = n.length),
        (this.indent_length = e.length),
        (this.raw = !1);
      var i = [];
      (this.baseIndentString = n),
        (this.indent_string = e),
        (this.previous_line = null),
        (this.current_line = null),
        (this.space_before_token = !1),
        (this.add_outputline = function () {
          (this.previous_line = this.current_line),
            (this.current_line = new s(this)),
            i.push(this.current_line);
        }),
        this.add_outputline(),
        (this.get_line_number = function () {
          return i.length;
        }),
        (this.add_new_line = function (t) {
          return (
            (1 !== this.get_line_number() || !this.just_added_newline()) &&
            !(!t && this.just_added_newline()) &&
            (this.raw || this.add_outputline(), !0)
          );
        }),
        (this.get_code = function () {
          return i.join('\n').replace(/[\r\n\t ]+$/, '');
        }),
        (this.set_indent = function (t) {
          if (1 < i.length) {
            for (; t >= this.indent_cache.length; )
              this.indent_cache.push(
                this.indent_cache[this.indent_cache.length - 1] +
                  this.indent_string
              );
            return this.current_line.set_indent(t), !0;
          }
          return this.current_line.set_indent(0), !1;
        }),
        (this.add_raw_token = function (t) {
          for (var e = 0; e < t.newlines; e++) this.add_outputline();
          this.current_line.push(t.whitespace_before),
            this.current_line.push(t.text),
            (this.space_before_token = !1);
        }),
        (this.add_token = function (t) {
          this.add_space_before_token(), this.current_line.push(t);
        }),
        (this.add_space_before_token = function () {
          this.space_before_token &&
            !this.just_added_newline() &&
            this.current_line.push(' '),
            (this.space_before_token = !1);
        }),
        (this.remove_redundant_indentation = function (t) {
          if (
            !t.multiline_frame &&
            t.mode !== Z.ForInitializer &&
            t.mode !== Z.Conditional
          )
            for (var e = t.start_line_index, n = i.length; e < n; )
              i[e].remove_indent(), e++;
        }),
        (this.trim = function (t) {
          for (
            t = t !== undefined && t, this.current_line.trim(e, n);
            t && 1 < i.length && this.current_line.is_empty();

          )
            i.pop(),
              (this.current_line = i[i.length - 1]),
              this.current_line.trim();
          this.previous_line = 1 < i.length ? i[i.length - 2] : null;
        }),
        (this.just_added_newline = function () {
          return this.current_line.is_empty();
        }),
        (this.just_added_blankline = function () {
          return (
            !!this.just_added_newline() &&
            (1 === i.length || i[i.length - 2].is_empty())
          );
        });
    }
    var J = function J(t, e, n, i, r, s) {
      (this.type = t),
        (this.text = e),
        (this.comments_before = []),
        (this.newlines = n || 0),
        (this.wanted_newline = 0 < n),
        (this.whitespace_before = i || ''),
        (this.parent = null),
        (this.directives = null);
    };
    function tt(k, y, t) {
      var O = '\n\r\t '.split(''),
        N = /[0-9]/,
        D = /[01234567]/,
        C = /[0123456789abcdefABCDEF]/,
        L = '+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>'.split(
          ' '
        );
      this.line_starters = 'continue,try,throw,return,const,let,const,if,switch,case,default,for,while,break,function,import,export'.split(
        ','
      );
      var I,
        V,
        P,
        B,
        j,
        M,
        U = this.line_starters.concat([
          'do',
          'in',
          'else',
          'get',
          'set',
          'new',
          'catch',
          'finally',
          'typeof',
          'yield',
          'async',
          'await'
        ]),
        W = /([\s\S]*?)((?:\*\/)|$)/g,
        z = /([^\n\r\u2028\u2029]*)/g,
        G = /\/\* beautify( \w+[:]\w+)+ \*\//g,
        X = / (\w+)[:](\w+)/g,
        F = /([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g,
        $ = /((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;
      function a() {
        var t,
          e,
          n = [];
        if (((I = 0), (V = ''), M <= j)) return ['', 'TK_EOF'];
        e = B.length ? B[B.length - 1] : new J('TK_START_BLOCK', '{');
        var i = k.charAt(j);
        for (j += 1; Y(i, O); ) {
          if (
            (Q.newline.test(i)
              ? ('\n' === i && '\r' === k.charAt(j - 2)) || ((I += 1), (n = []))
              : n.push(i),
            M <= j)
          )
            return ['', 'TK_EOF'];
          (i = k.charAt(j)), (j += 1);
        }
        if ((n.length && (V = n.join('')), N.test(i))) {
          var r = !0,
            s = !0,
            a = N;
          for (
            '0' === i && j < M && /[Xxo]/.test(k.charAt(j))
              ? ((s = r = !1),
                (i += k.charAt(j)),
                (j += 1),
                (a = /[o]/.test(k.charAt(j)) ? D : C))
              : ((i = ''), (j -= 1));
            j < M && a.test(k.charAt(j));

          )
            (i += k.charAt(j)),
              (j += 1),
              r &&
                j < M &&
                '.' === k.charAt(j) &&
                ((i += k.charAt(j)), (j += 1), (r = !1)),
              s &&
                j < M &&
                /[Ee]/.test(k.charAt(j)) &&
                ((i += k.charAt(j)),
                (j += 1) < M &&
                  /[+-]/.test(k.charAt(j)) &&
                  ((i += k.charAt(j)), (j += 1)),
                (r = s = !1));
          return [i, 'TK_WORD'];
        }
        if (Q.isIdentifierStart(k.charCodeAt(j - 1))) {
          if (j < M)
            for (
              ;
              Q.isIdentifierChar(k.charCodeAt(j)) &&
              ((i += k.charAt(j)), (j += 1) !== M);

            );
          return 'TK_DOT' === e.type ||
            ('TK_RESERVED' === e.type && Y(e.text, ['set', 'get'])) ||
            !Y(i, U)
            ? [i, 'TK_WORD']
            : 'in' === i
            ? [i, 'TK_OPERATOR']
            : [i, 'TK_RESERVED'];
        }
        if ('(' === i || '[' === i) return [i, 'TK_START_EXPR'];
        if (')' === i || ']' === i) return [i, 'TK_END_EXPR'];
        if ('{' === i) return [i, 'TK_START_BLOCK'];
        if ('}' === i) return [i, 'TK_END_BLOCK'];
        if (' ' === i) return [i, 'TK_SEMICOLON'];
        if ('/' === i) {
          var _ = '';
          if ('*' === k.charAt(j)) {
            (j += 1), (W.lastIndex = j);
            var o = W.exec(k);
            (_ = '/*'.concat(o[0])), (j += o[0].length);
            var c = (function S(t) {
              if (!t.match(G)) return null;
              var e = {};
              X.lastIndex = 0;
              for (var n = X.exec(t); n; ) (e[n[1]] = n[2]), (n = X.exec(t));
              return e;
            })(_);
            return (
              c &&
                'start' === c.ignore &&
                ((F.lastIndex = j),
                (_ += (o = F.exec(k))[0]),
                (j += o[0].length)),
              [(_ = _.replace(Q.lineBreak, '\n')), 'TK_BLOCK_COMMENT', c]
            );
          }
          if ('/' === k.charAt(j)) {
            (j += 1), (z.lastIndex = j);
            var l = z.exec(k);
            return (
              (_ = '//'.concat(l[0])), (j += l[0].length), [_, 'TK_COMMENT']
            );
          }
        }
        if (
          '`' === i ||
          "'" === i ||
          '"' === i ||
          (('/' === i ||
            (y.e4x &&
              '<' === i &&
              k
                .slice(j - 1)
                .match(
                  /^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/
                ))) &&
            (('TK_RESERVED' === e.type &&
              Y(e.text, [
                'return',
                'case',
                'throw',
                'else',
                'do',
                'typeof',
                'yield'
              ])) ||
              ('TK_END_EXPR' === e.type &&
                ')' === e.text &&
                e.parent &&
                'TK_RESERVED' === e.parent.type &&
                Y(e.parent.text, ['if', 'while', 'for'])) ||
              Y(e.type, [
                'TK_COMMENT',
                'TK_START_EXPR',
                'TK_START_BLOCK',
                'TK_END_BLOCK',
                'TK_OPERATOR',
                'TK_EQUALS',
                'TK_EOF',
                'TK_SEMICOLON',
                'TK_COMMA'
              ])))
        ) {
          var h = i,
            u = !1,
            p = !1;
          if (((t = i), '/' === h))
            for (
              var d = !1;
              j < M &&
              (u || d || k.charAt(j) !== h) &&
              !Q.newline.test(k.charAt(j));

            )
              (t += k.charAt(j)),
                u
                  ? (u = !1)
                  : ((u = '\\' === k.charAt(j)),
                    '[' === k.charAt(j)
                      ? (d = !0)
                      : ']' === k.charAt(j) && (d = !1)),
                (j += 1);
          else if (y.e4x && '<' === h) {
            var f = /<(\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/g,
              T = k.slice(j - 1),
              E = f.exec(T);
            if (E && 0 === E.index) {
              for (var g = E[2], x = 0; E; ) {
                var w = !!E[1],
                  K = E[2],
                  R = !!E[E.length - 1] || '![CDATA[' === K.slice(0, 8);
                if ((K !== g || R || (w ? --x : ++x), x <= 0)) break;
                E = f.exec(T);
              }
              var m = E ? E.index + E[0].length : T.length;
              return (
                (T = T.slice(0, m)),
                (j += m - 1),
                [(T = T.replace(Q.lineBreak, '\n')), 'TK_STRING']
              );
            }
          } else
            for (
              ;
              j < M &&
              (u ||
                (k.charAt(j) !== h &&
                  ('`' === h || !Q.newline.test(k.charAt(j)))));

            )
              (u || '`' === h) && Q.newline.test(k.charAt(j))
                ? ('\r' === k.charAt(j) && '\n' === k.charAt(j + 1) && (j += 1),
                  (t += '\n'))
                : (t += k.charAt(j)),
                (u = u
                  ? (('x' !== k.charAt(j) && 'u' !== k.charAt(j)) || (p = !0),
                    !1)
                  : '\\' === k.charAt(j)),
                (j += 1);
          if (
            (p &&
              y.unescape_strings &&
              (t = (function A(t) {
                var e,
                  n = !1,
                  i = '',
                  r = 0,
                  s = '',
                  a = 0;
                for (; n || r < t.length; )
                  if (((e = t.charAt(r)), r++, n)) {
                    if (((n = !1), 'x' === e)) (s = t.substr(r, 2)), (r += 2);
                    else {
                      if ('u' !== e) {
                        i += '\\'.concat(e);
                        continue;
                      }
                      (s = t.substr(r, 4)), (r += 4);
                    }
                    if (!s.match(/^[0123456789abcdefABCDEF]+$/)) return t;
                    if (0 <= (a = parseInt(s, 16)) && a < 32) {
                      i += 'x' === e ? '\\x'.concat(s) : '\\u'.concat(s);
                      continue;
                    }
                    if (34 === a || 39 === a || 92 === a)
                      i += '\\'.concat(String.fromCharCode(a));
                    else {
                      if ('x' === e && 126 < a && a <= 255) return t;
                      i += String.fromCharCode(a);
                    }
                  } else '\\' === e ? (n = !0) : (i += e);
                return i;
              })(t)),
            j < M && k.charAt(j) === h && ((t += h), (j += 1), '/' === h))
          )
            for (; j < M && Q.isIdentifierStart(k.charCodeAt(j)); )
              (t += k.charAt(j)), (j += 1);
          return [t, 'TK_STRING'];
        }
        if ('#' === i) {
          if (0 === B.length && '!' === k.charAt(j)) {
            for (t = i; j < M && '\n' !== i; ) (t += i = k.charAt(j)), (j += 1);
            return [''.concat(H(t), '\n'), 'TK_UNKNOWN'];
          }
          var b = '#';
          if (j < M && N.test(k.charAt(j))) {
            for (
              ;
              (b += i = k.charAt(j)), (j += 1) < M && '#' !== i && '=' !== i;

            );
            return (
              '#' === i ||
                ('[' === k.charAt(j) && ']' === k.charAt(j + 1)
                  ? ((b += '[]'), (j += 2))
                  : '{' === k.charAt(j) &&
                    '}' === k.charAt(j + 1) &&
                    ((b += '{}'), (j += 2))),
              [b, 'TK_WORD']
            );
          }
        }
        if ('<' === i && ('?' === k.charAt(j) || '%' === k.charAt(j))) {
          $.lastIndex = j - 1;
          var v = $.exec(k);
          if (v)
            return (
              (i = v[0]),
              (j += i.length - 1),
              [(i = i.replace(Q.lineBreak, '\n')), 'TK_STRING']
            );
        }
        if ('<' === i && '\x3c!--' === k.substring(j - 1, j + 3)) {
          for (j += 3, i = '\x3c!--'; !Q.newline.test(k.charAt(j)) && j < M; )
            (i += k.charAt(j)), j++;
          return (P = !0), [i, 'TK_COMMENT'];
        }
        if ('-' === i && P && '--\x3e' === k.substring(j - 1, j + 2))
          return (P = !1), (j += 2), ['--\x3e', 'TK_COMMENT'];
        if ('.' === i) return [i, 'TK_DOT'];
        if (Y(i, L)) {
          for (
            ;
            j < M &&
            Y(i + k.charAt(j), L) &&
            ((i += k.charAt(j)), !(M <= (j += 1)));

          );
          return ',' === i
            ? [i, 'TK_COMMA']
            : '=' === i
            ? [i, 'TK_EQUALS']
            : [i, 'TK_OPERATOR'];
        }
        return [i, 'TK_UNKNOWN'];
      }
      this.tokenize = function () {
        var t, e, n;
        (M = k.length), (j = 0), (P = !1), (B = []);
        for (var i = null, r = [], s = []; !e || 'TK_EOF' !== e.type; ) {
          for (
            n = a(), t = new J(n[1], n[0], I, V);
            'TK_COMMENT' === t.type ||
            'TK_BLOCK_COMMENT' === t.type ||
            'TK_UNKNOWN' === t.type;

          )
            'TK_BLOCK_COMMENT' === t.type && (t.directives = n[2]),
              s.push(t),
              (n = a()),
              (t = new J(n[1], n[0], I, V));
          s.length && ((t.comments_before = s), (s = [])),
            'TK_START_BLOCK' === t.type || 'TK_START_EXPR' === t.type
              ? ((t.parent = e), r.push(i), (i = t))
              : ('TK_END_BLOCK' === t.type || 'TK_END_EXPR' === t.type) &&
                i &&
                ((']' === t.text && '[' === i.text) ||
                  (')' === t.text && '(' === i.text) ||
                  ('}' === t.text && '{' === i.text)) &&
                ((t.parent = i.parent), (i = r.pop())),
            B.push(t),
            (e = t);
        }
        return B;
      };
    }
    return {
      run: function N(t, e) {
        function a(t) {
          return t.replace(/\s+$/g, '');
        }
        var n, i, r, T, s, _, E, o, c, g, x, w, l, h;
        for (
          ((e = e || {}).wrap_line_length !== undefined &&
            0 !== parseInt(e.wrap_line_length, 10)) ||
            e.max_char === undefined ||
            0 === parseInt(e.max_char, 10) ||
            (e.wrap_line_length = e.max_char),
            i = e.indent_inner_html !== undefined && e.indent_inner_html,
            r = e.indent_size === undefined ? 4 : parseInt(e.indent_size, 10),
            T = e.indent_char === undefined ? ' ' : e.indent_char,
            _ = e.brace_style === undefined ? 'collapse' : e.brace_style,
            s =
              0 === parseInt(e.wrap_line_length, 10)
                ? 32786
                : parseInt(e.wrap_line_length || 250, 10),
            E = e.unformatted || [
              'a',
              'span',
              'img',
              'bdo',
              'em',
              'strong',
              'dfn',
              'code',
              'samp',
              'kbd',
              'const',
              'cite',
              'abbr',
              'acronym',
              'q',
              'sub',
              'sup',
              'tt',
              'i',
              'b',
              'big',
              'small',
              'u',
              's',
              'strike',
              'font',
              'ins',
              'del',
              'address',
              'pre'
            ],
            o = e.preserve_newlines === undefined || e.preserve_newlines,
            c = o
              ? isNaN(parseInt(e.max_preserve_newlines, 10))
                ? 32786
                : parseInt(e.max_preserve_newlines, 10)
              : 0,
            g = e.indent_handlebars !== undefined && e.indent_handlebars,
            x = e.wrap_attributes === undefined ? 'auto' : e.wrap_attributes,
            w =
              e.wrap_attributes_indent_size === undefined
                ? r
                : parseInt(e.wrap_attributes_indent_size, 10) || r,
            l = e.end_with_newline !== undefined && e.end_with_newline,
            h = Array.isArray(e.extra_liners)
              ? e.extra_liners.concat()
              : 'string' == typeof e.extra_liners
              ? e.extra_liners.split(',')
              : 'head,body,/html'.split(','),
            e.indent_with_tabs && ((T = '\t'), (r = 1)),
            (n = new (function k() {
              return (
                (this.pos = 0),
                (this.token = ''),
                (this.current_mode = 'CONTENT'),
                (this.tags = {
                  parent: 'parent1',
                  parentcount: 1,
                  parent1: ''
                }),
                (this.tag_type = ''),
                (this.token_text = this.last_token = this.last_text = this.token_type =
                  ''),
                (this.newlines = 0),
                (this.indent_content = i),
                (this.Utils = {
                  whitespace: '\n\r\t '.split(''),
                  single_token: 'br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed'.split(
                    ','
                  ),
                  extra_liners: h,
                  in_array: function (t, e) {
                    for (var n = 0; n < e.length; n++)
                      if (t === e[n]) return !0;
                    return !1;
                  }
                }),
                (this.is_whitespace = function (t) {
                  for (; 0 < t.length; t++)
                    if (
                      !this.Utils.in_array(t.charAt(0), this.Utils.whitespace)
                    )
                      return !1;
                  return !0;
                }),
                (this.traverse_whitespace = function () {
                  var t = '';
                  if (
                    ((t = this.input.charAt(this.pos)),
                    this.Utils.in_array(t, this.Utils.whitespace))
                  ) {
                    for (
                      this.newlines = 0;
                      this.Utils.in_array(t, this.Utils.whitespace);

                    )
                      o &&
                        '\n' === t &&
                        this.newlines <= c &&
                        (this.newlines += 1),
                        this.pos++,
                        (t = this.input.charAt(this.pos));
                    return !0;
                  }
                  return !1;
                }),
                (this.space_or_wrap = function (t) {
                  this.line_char_count >= this.wrap_line_length
                    ? (this.print_newline(!1, t), this.print_indentation(t))
                    : (this.line_char_count++, t.push(' '));
                }),
                (this.get_content = function () {
                  for (
                    var t = '', e = [];
                    '<' != this.input.charAt(this.pos);

                  ) {
                    if (this.pos >= this.input.length)
                      return e.length ? e.join('') : ['', 'TK_EOF'];
                    if (this.traverse_whitespace()) this.space_or_wrap(e);
                    else {
                      if (g) {
                        var n = this.input.substr(this.pos, 3);
                        if ('{{#' === n || '{{/' === n) break;
                        if ('{{!' === n)
                          return [this.get_tag(), 'TK_TAG_HANDLEBARS_COMMENT'];
                        if (
                          '{{' === this.input.substr(this.pos, 2) &&
                          '{{else}}' === this.get_tag(!0)
                        )
                          break;
                      }
                      (t = this.input.charAt(this.pos)),
                        this.pos++,
                        this.line_char_count++,
                        e.push(t);
                    }
                  }
                  return e.length ? e.join('') : '';
                }),
                (this.get_contents_to = function (t) {
                  if (this.pos === this.input.length) return ['', 'TK_EOF'];
                  var e = '',
                    n = new RegExp('</'.concat(t, '\\s*>'), 'igm');
                  n.lastIndex = this.pos;
                  var i = n.exec(this.input),
                    r = i ? i.index : this.input.length;
                  return (
                    this.pos < r &&
                      ((e = this.input.substring(this.pos, r)), (this.pos = r)),
                    e
                  );
                }),
                (this.record_tag = function (t) {
                  this.tags[''.concat(t, 'count')]
                    ? this.tags[''.concat(t, 'count')]++
                    : (this.tags[''.concat(t, 'count')] = 1),
                    (this.tags[
                      t + this.tags[''.concat(t, 'count')]
                    ] = this.indent_level),
                    (this.tags[
                      `${t + this.tags[''.concat(t, 'count')]}parent`
                    ] = this.tags.parent),
                    (this.tags.parent = t + this.tags[''.concat(t, 'count')]);
                }),
                (this.retrieve_tag = function (t) {
                  if (this.tags[''.concat(t, 'count')]) {
                    for (
                      var e = this.tags.parent;
                      e && t + this.tags[''.concat(t, 'count')] !== e;

                    )
                      e = this.tags[''.concat(e, 'parent')];
                    e &&
                      ((this.indent_level = this.tags[
                        t + this.tags[''.concat(t, 'count')]
                      ]),
                      (this.tags.parent = this.tags[`${e}parent`])),
                      delete this.tags[
                        `${t + this.tags[''.concat(t, 'count')]}parent`
                      ],
                      delete this.tags[t + this.tags[''.concat(t, 'count')]],
                      1 === this.tags[''.concat(t, 'count')]
                        ? delete this.tags[''.concat(t, 'count')]
                        : this.tags[''.concat(t, 'count')]--;
                  }
                }),
                (this.indent_to_tag = function (t) {
                  if (this.tags[''.concat(t, 'count')]) {
                    for (
                      var e = this.tags.parent;
                      e && t + this.tags[''.concat(t, 'count')] !== e;

                    )
                      e = this.tags[''.concat(e, 'parent')];
                    e &&
                      (this.indent_level = this.tags[
                        t + this.tags[''.concat(t, 'count')]
                      ]);
                  }
                }),
                (this.get_tag = function (t) {
                  var e,
                    n,
                    i = '',
                    r = [],
                    s = '',
                    a = !1,
                    _ = !0,
                    o = this.pos,
                    c = this.line_char_count;
                  t = t !== undefined && t;
                  do {
                    if (this.pos >= this.input.length)
                      return (
                        t && ((this.pos = o), (this.line_char_count = c)),
                        r.length ? r.join('') : ['', 'TK_EOF']
                      );
                    if (
                      ((i = this.input.charAt(this.pos)),
                      this.pos++,
                      this.Utils.in_array(i, this.Utils.whitespace))
                    )
                      a = !0;
                    else {
                      if (
                        (("'" !== i && '"' !== i) ||
                          ((i += this.get_unformatted(i)), (a = !0)),
                        '=' === i && (a = !1),
                        r.length && '=' != r[r.length - 1] && '>' != i && a)
                      ) {
                        if (
                          (this.space_or_wrap(r),
                          (a = !1),
                          !_ && 'force' === x && '/' != i)
                        ) {
                          this.print_newline(!0, r), this.print_indentation(r);
                          for (var l = 0; l < w; l++) r.push(T);
                        }
                        for (var h = 0; h < r.length; h++)
                          if (' ' === r[h]) {
                            _ = !1;
                            break;
                          }
                      }
                      if (
                        (g &&
                          '<' === n &&
                          i + this.input.charAt(this.pos) === '{{' &&
                          ((i += this.get_unformatted('}}')),
                          r.length &&
                            ' ' != r[r.length - 1] &&
                            '<' != r[r.length - 1] &&
                            (i = ' '.concat(i)),
                          (a = !0)),
                        '<' !== i || n || ((e = this.pos - 1), (n = '<')),
                        g &&
                          !n &&
                          2 <= r.length &&
                          '{' === r[r.length - 1] &&
                          '{' === r[r.length - 2] &&
                          ((e =
                            '#' === i || '/' === i || '!' === i
                              ? this.pos - 3
                              : this.pos - 2),
                          (n = '{')),
                        this.line_char_count++,
                        r.push(i),
                        r[1] && ('!' === r[1] || '?' === r[1] || '%' === r[1]))
                      ) {
                        r = [this.get_comment(e)];
                        break;
                      }
                      if (g && r[1] && '{' === r[1] && r[2] && '!' === r[2]) {
                        r = [this.get_comment(e)];
                        break;
                      }
                      if (
                        g &&
                        '{' === n &&
                        2 < r.length &&
                        '}' === r[r.length - 2] &&
                        '}' === r[r.length - 1]
                      )
                        break;
                    }
                  } while ('>' != i);
                  var u,
                    p,
                    d = r.join('');
                  (u =
                    -1 != d.indexOf(' ')
                      ? d.indexOf(' ')
                      : '{' === d[0]
                      ? d.indexOf('}')
                      : d.indexOf('>')),
                    (p = '<' !== d[0] && g ? ('#' === d[2] ? 3 : 2) : 1);
                  var f = d.substring(p, u).toLowerCase();
                  return (
                    '/' === d.charAt(d.length - 2) ||
                    this.Utils.in_array(f, this.Utils.single_token)
                      ? t || (this.tag_type = 'SINGLE')
                      : g && '{' === d[0] && 'else' === f
                      ? t ||
                        (this.indent_to_tag('if'),
                        (this.tag_type = 'HANDLEBARS_ELSE'),
                        (this.indent_content = !0),
                        this.traverse_whitespace())
                      : this.is_unformatted(f, E)
                      ? ((s = this.get_unformatted('</'.concat(f, '>'), d)),
                        r.push(s),
                        this.pos,
                        (this.tag_type = 'SINGLE'))
                      : 'script' === f &&
                        (-1 === d.search('type') ||
                          (-1 < d.search('type') &&
                            -1 <
                              d.search(
                                /\b(text|application)\/(x-)?(javascript|ecmascript|jscript|livescript)/
                              )))
                      ? t || (this.record_tag(f), (this.tag_type = 'SCRIPT'))
                      : 'style' === f &&
                        (-1 === d.search('type') ||
                          (-1 < d.search('type') && -1 < d.search('text/css')))
                      ? t || (this.record_tag(f), (this.tag_type = 'STYLE'))
                      : '!' === f.charAt(0)
                      ? t ||
                        ((this.tag_type = 'SINGLE'), this.traverse_whitespace())
                      : t ||
                        ('/' === f.charAt(0)
                          ? (this.retrieve_tag(f.substring(1)),
                            (this.tag_type = 'END'))
                          : (this.record_tag(f),
                            'html' != f.toLowerCase() &&
                              (this.indent_content = !0),
                            (this.tag_type = 'START')),
                        this.traverse_whitespace() && this.space_or_wrap(r),
                        this.Utils.in_array(f, this.Utils.extra_liners) &&
                          (this.print_newline(!1, this.output),
                          this.output.length &&
                            '\n' != this.output[this.output.length - 2] &&
                            this.print_newline(!0, this.output))),
                    t && ((this.pos = o), (this.line_char_count = c)),
                    r.join('')
                  );
                }),
                (this.get_comment = function (t) {
                  var e = '',
                    n = '>',
                    i = !1;
                  this.pos = t;
                  var r = this.input.charAt(this.pos);
                  for (
                    this.pos++;
                    this.pos <= this.input.length &&
                    ((e += r)[e.length - 1] !== n[n.length - 1] ||
                      -1 == e.indexOf(n));

                  )
                    !i &&
                      e.length < 10 &&
                      (0 === e.indexOf('<![if')
                        ? ((n = '<![endif]>'), (i = !0))
                        : 0 === e.indexOf('<![cdata[')
                        ? ((n = ']]>'), (i = !0))
                        : 0 === e.indexOf('<![')
                        ? ((n = ']>'), (i = !0))
                        : 0 === e.indexOf('\x3c!--')
                        ? ((n = '--\x3e'), (i = !0))
                        : 0 === e.indexOf('{{!')
                        ? ((n = '}}'), (i = !0))
                        : 0 === e.indexOf('<?')
                        ? ((n = '?>'), (i = !0))
                        : 0 === e.indexOf('<%') && ((n = '%>'), (i = !0))),
                      (r = this.input.charAt(this.pos)),
                      this.pos++;
                  return e;
                }),
                (this.get_unformatted = function (t, e) {
                  if (e && -1 != e.toLowerCase().indexOf(t)) return '';
                  var n = '',
                    i = '',
                    r = 0,
                    s = !0;
                  do {
                    if (this.pos >= this.input.length) return i;
                    if (
                      ((n = this.input.charAt(this.pos)),
                      this.pos++,
                      this.Utils.in_array(n, this.Utils.whitespace))
                    ) {
                      if (!s) {
                        this.line_char_count--;
                        continue;
                      }
                      if ('\n' === n || '\r' === n) {
                        (i += '\n'), (this.line_char_count = 0);
                        continue;
                      }
                    }
                    (i += n),
                      this.line_char_count++,
                      (s = !0),
                      g &&
                        '{' === n &&
                        i.length &&
                        '{' === i[i.length - 2] &&
                        (r = (i += this.get_unformatted('}}')).length);
                  } while (-1 === i.toLowerCase().indexOf(t, r));
                  return i;
                }),
                (this.get_token = function () {
                  var t;
                  if (
                    'TK_TAG_SCRIPT' !== this.last_token &&
                    'TK_TAG_STYLE' !== this.last_token
                  )
                    return 'CONTENT' === this.current_mode
                      ? 'string' != typeof (t = this.get_content())
                        ? t
                        : [t, 'TK_CONTENT']
                      : 'TAG' === this.current_mode
                      ? 'string' != typeof (t = this.get_tag())
                        ? t
                        : [t, 'TK_TAG_'.concat(this.tag_type)]
                      : void 0;
                  var e = this.last_token.substr(7);
                  return 'string' != typeof (t = this.get_contents_to(e))
                    ? t
                    : [t, 'TK_'.concat(e)];
                }),
                (this.get_full_indent = function (t) {
                  return (t = this.indent_level + t || 0) < 1
                    ? ''
                    : new Array(t + 1).join(this.indent_string);
                }),
                (this.is_unformatted = function (t, e) {
                  if (!this.Utils.in_array(t, e)) return !1;
                  if ('a' != t.toLowerCase() || !this.Utils.in_array('a', e))
                    return !0;
                  var n = (this.get_tag(!0) || '').match(
                    /^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/
                  );
                  return !(n && !this.Utils.in_array(n, e));
                }),
                (this.printer = function (t, e, n, i, r) {
                  (this.input = t || ''),
                    (this.output = []),
                    (this.indent_character = e),
                    (this.indent_string = ''),
                    (this.indent_size = n),
                    (this.brace_style = r),
                    (this.indent_level = 0),
                    (this.wrap_line_length = i);
                  for (
                    var s = (this.line_char_count = 0);
                    s < this.indent_size;
                    s++
                  )
                    this.indent_string += this.indent_character;
                  (this.print_newline = function (t, e) {
                    (this.line_char_count = 0),
                      e &&
                        e.length &&
                        (t || '\n' != e[e.length - 1]) &&
                        ('\n' != e[e.length - 1] &&
                          (e[e.length - 1] = a(e[e.length - 1])),
                        e.push('\n'));
                  }),
                    (this.print_indentation = function (t) {
                      for (var e = 0; e < this.indent_level; e++)
                        t.push(this.indent_string),
                          (this.line_char_count += this.indent_string.length);
                    }),
                    (this.print_token = function (t) {
                      (this.is_whitespace(t) && !this.output.length) ||
                        ((t || '' !== t) &&
                          this.output.length &&
                          '\n' === this.output[this.output.length - 1] &&
                          (this.print_indentation(this.output),
                          (t = (function e(t) {
                            return t.replace(/^\s+/g, '');
                          })(t))),
                        this.print_token_raw(t));
                    }),
                    (this.print_token_raw = function (t) {
                      0 < this.newlines && (t = a(t)),
                        t &&
                          '' !== t &&
                          (1 < t.length && '\n' === t[t.length - 1]
                            ? (this.output.push(t.slice(0, -1)),
                              this.print_newline(!1, this.output))
                            : this.output.push(t));
                      for (var e = 0; e < this.newlines; e++)
                        this.print_newline(0 < e, this.output);
                      this.newlines = 0;
                    }),
                    (this.indent = function () {
                      this.indent_level++;
                    }),
                    (this.unindent = function () {
                      0 < this.indent_level && this.indent_level--;
                    });
                }),
                this
              );
            })()).printer(t, T, r, s, _);
          ;

        ) {
          var u = n.get_token();
          if (
            ((n.token_text = u[0]),
            (n.token_type = u[1]),
            'TK_EOF' === n.token_type)
          )
            break;
          switch (n.token_type) {
            case 'TK_TAG_START':
              n.print_newline(!1, n.output),
                n.print_token(n.token_text),
                n.indent_content && (n.indent(), (n.indent_content = !1)),
                (n.current_mode = 'CONTENT');
              break;
            case 'TK_TAG_STYLE':
            case 'TK_TAG_SCRIPT':
              n.print_newline(!1, n.output),
                n.print_token(n.token_text),
                (n.current_mode = 'CONTENT');
              break;
            case 'TK_TAG_END':
              if ('TK_CONTENT' === n.last_token && '' === n.last_text) {
                var p = n.token_text.match(/\w+/)[0],
                  d = null;
                n.output.length &&
                  (d = n.output[n.output.length - 1].match(
                    /(?:<|{{#)\/?\s*(\w+)/
                  )),
                  (null === d || (d[1] != p && !n.Utils.in_array(d[1], E))) &&
                    n.print_newline(!1, n.output);
              }
              n.print_token(n.token_text), (n.current_mode = 'CONTENT');
              break;
            case 'TK_TAG_SINGLE':
              var f = n.token_text.match(/^\s*<([a-z-]+)/i);
              (f && n.Utils.in_array(f[1], E)) || n.print_newline(!1, n.output),
                n.print_token(n.token_text),
                (n.current_mode = 'CONTENT');
              break;
            case 'TK_TAG_HANDLEBARS_ELSE':
              n.print_token(n.token_text),
                n.indent_content && (n.indent(), (n.indent_content = !1)),
                (n.current_mode = 'CONTENT');
              break;
            case 'TK_TAG_HANDLEBARS_COMMENT':
            case 'TK_CONTENT':
              n.print_token(n.token_text), (n.current_mode = 'TAG');
              break;
            case 'TK_STYLE':
            case 'TK_SCRIPT':
              if ('' !== n.token_text) {
                n.print_newline(!1, n.output);
                var K = n.token_text,
                  R = void 0,
                  m = 1;
                'TK_SCRIPT' === n.token_type
                  ? (R = O)
                  : 'TK_STYLE' === n.token_type && (R = y),
                  'keep' === e.indent_scripts
                    ? (m = 0)
                    : 'separate' === e.indent_scripts && (m = -n.indent_level);
                var b = n.get_full_indent(m);
                if (R) K = R(K.replace(/^\s*/, b), e);
                else {
                  var v =
                      K.match(/^\s*/)[0]
                        .match(/[^\n\r]*$/)[0]
                        .split(n.indent_string).length - 1,
                    S = n.get_full_indent(m - v);
                  K = K.replace(/^\s*/, b)
                    .replace(/\r\n|\r|\n/g, `\n${S}`)
                    .replace(/\s+$/, '');
                }
                K && (n.print_token_raw(K), n.print_newline(!0, n.output));
              }
              n.current_mode = 'TAG';
              break;
            default:
              '' !== n.token_text && n.print_token(n.token_text);
          }
          (n.last_token = n.token_type), (n.last_text = n.token_text);
        }
        var A = n.output.join('').replace(/[\r\n\t ]+$/, '');
        return l && (A += '\n'), A;
      }
    };
  };
});
